/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2021. All rights reserved
------------------------------------------------------------------------------------------------- */

import { css, html, LitElement } from 'lit-element';

/**
 * @prop {String} orientation - Defines whether the orientation of the toolbar. Accepted values are vertical or horizontal.
 * @prop {Boolean}  inSegmentTheme - If set, the toolbar and its contained UI elements would be the style from dark theme on the light-themed page.
 * @slot - Takes plain text as a child element.
 */

export class SHToolbar extends LitElement {
  static get properties() {
    return {
      orientation: { type: String, reflect: true },
      inSegmentTheme: { type: Boolean, reflect: true, attribute: 'in-segment-theme' },
    };
  }

  render() {
    return html` <slot></slot> `;
  }

  static get styles() {
    return [
      css`
        :host {
          display: flex;
          background: rgba(var(--ui-6), var(--opacity-2));
          border-radius: 0.125rem;
        }
        :host([orientation='horizontal']),
        :host([slot='top']),
        :host([slot='bottom']) {
          flex-direction: row;
        }
        :host([orientation='vertical']),
        :host([slot='left']),
        :host([slot='right']) {
          flex-direction: column;
        }
      `,
    ];
  }
}

customElements.define('sh-toolbar', SHToolbar);
